import React from "react";
import { Link } from "react-scroll";
import { RiGithubLine } from "react-icons/ri";
import { GrInstagram } from "react-icons/gr";

import { FiYoutube } from "react-icons/fi";
import { ImLinkedin2 } from "react-icons/im";

const Navbar = () => {
  return (
    <>
      <nav className="main-nav">
        <div className="logo">
          <span>Portfolio</span>
        </div>

        <div>
          <ul className="menu-link">
            <li>
              <Link className="linker" to="about" duration={1000}>
                About Me
              </Link>
            </li>
            <li>
              <Link className="linker" to="project" duration={1000}>
                Project
              </Link>
            </li>
            <li>
              <Link className="linker" to="technologies" duration={1000}>
                Technologies
              </Link>
            </li>
            <li>
              <Link className="linker" to="education" duration={1000}>
                Education
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <ul className="social">
            <li>
              <a
                href="https://github.com/prathu0603"
                target="_blank"
                rel="noreferrer"
              >
                <RiGithubLine className="github" />
              </a>
            </li>
            <li>
              <a
                href="https://www.linkedin.com/in/prathamesh-sarode-39574719a/"
                target="_blank"
                rel="noreferrer"
              >
                <ImLinkedin2 className="linkedin" />
              </a>
            </li>
            {/* <li>
              <a
                href="https://www.instagram.com/dark_0603/"
                target="_blank"
                rel="noreferrer"
              >
                <GrInstagram className="instagram" />
              </a>
            </li>
            <li>
              <a
                href="https://www.youtube.com/channel/UCqRjHL9SGisPE7Uh5VqGWig/featured"
                target="_blank"
                rel="noreferrer"
              >
                <FiYoutube className="youtube" />
              </a>
            </li> */}
          </ul>
        </div>
      </nav>

      <nav className="mobile_nav">
        <div className="logo">
          <span>Portfolio</span>
        </div>

        <div className="mobile_links">
          <ul>
            <li>
              <Link className="mobile_a" to="about" duration={1000}>
                About Me
              </Link>
            </li>
            <li>
              <Link className="mobile_a" to="project" duration={1000}>
                Project
              </Link>
            </li>
            <li>
              <Link className="mobile_a" to="technologies" duration={1000}>
                Technologies
              </Link>
            </li>
            <li>
              <Link
                className="mobile_a last_one"
                to="education"
                duration={1000}
              >
                Education
              </Link>
            </li>
          </ul>
        </div>

        <div className="mobile_social">
          <a
            className="mobile_social_a"
            href="https://github.com/prathu0603"
            target="_blank"
            rel="noreferrer"
          >
            <RiGithubLine className="github" />
          </a>

          <a
            className="mobile_social_a"
            href="https://www.linkedin.com/in/prathamesh-sarode-39574719a/"
            target="_blank"
            rel="noreferrer"
          >
            <ImLinkedin2 className="linkedin" />
          </a>

          {/* <a
            className="mobile_social_a"
            href="https://www.instagram.com/dark_0603/"
            target="_blank"
            rel="noreferrer"
          >
            <GrInstagram className="instagram" />
          </a>

          <a
            className="mobile_social_a last_social"
            href="https://www.youtube.com/channel/UCqRjHL9SGisPE7Uh5VqGWig/featured"
            target="_blank"
            rel="noreferrer"
          >
            <FiYoutube className="youtube" />
          </a> */}
        </div>
      </nav>
    </>
  );
};

export default Navbar;
